import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import uuid from 'uuid';

import { TabHorizontal } from '../../core/TabsHorizontal';
import DocumentItem from '../../core/ResultItem/DocumentItem';
import NewsItem from '../../core/ResultItem/NewsItem';
import EventItem from '../../core/ResultItem/EventItem';
import GroupItem from '../../core/ResultItem/GroupItem';
import SectionItem from '../../core/ResultItem/SectionItem';
import PersonItem from '../../core/ResultItem/PersonItem';
import ErrorPageSearch from '../../core/ErrorPageSearch';
import { Close, News } from '../../../../assets/images';
import Logo from '../../../../assets/images/logo.svg';

import { SearchModel } from '../../../model';
import { getImageLink } from '../../../utils/resources';

import {
  API_DOCUMENTS_DOWNLOAD,
  API_PRESS_DOWNLOAD
} from '../../../constants/api';

import { getFolderPath } from '../../../utils/apiDepartment';

import {
  StyledSearchModal,
  WrapperLogo,
  IconLogo,
  MainSearch,
  FormSearch,
  TabsSearch,
  ItemResult,
  SearchPaginator,
  IconClose
} from './style';

/** Utils */
import { navigateToFile } from '../../../utils/navigate';

class SearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mount: true
    };
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  getDocument = (e, filePath, resultType) => {
    const { onClose } = this.props;
    const url =
      resultType === 'DOCUMENT'
        ? `${API_DOCUMENTS_DOWNLOAD}`
        : `${API_PRESS_DOWNLOAD}`;

    e.preventDefault();
    navigateToFile(`${url}${filePath}`);
    onClose();
  };

  getFolder = item => {
    const { history } = this.props;
    getFolderPath(item.id).then(resp => {
      this.handleClose();
      history.push({
        pathname: `/documentos-intranet/${resp[0].txt}`,
        search: `?folderId=${item.id}`,
        state: {
          currentFolder: item.id,
          breadcrumbData: resp
        }
      });
    });
  };

  handleClose = () => {
    const { onClose } = this.props;

    this.setState(
      {
        mount: false
      },
      () => setTimeout(onClose, 300)
    );
  };

  getUrlFromSection = url => url.replace('userId', this.props.user.userId);

  getContent = item => {
    const { onClose } = this.props;

    switch (item.baseContentType) {
      case 'NEWSREVIEW':
        return (
          <DocumentItem
            title={item.title}
            date={item.publishDate}
            urlLink="#"
            onClick={e => this.getDocument(e, item.clientPath, item.resultType)}
            icon={News}
          />
        );
      case 'EVENT':
        return (
          <EventItem
            imgSrc={getImageLink(item.imagePath)}
            title={item.title}
            date={item.startDate}
            dateEnd={item.closeDate}
            text={item.subtitle}
            urlLink={`/agenda/${item.id}`}
            onClick={() => onClose()}
          />
        );
      case 'NEWS':
      default:
        return (
          <NewsItem
            imgSrc={getImageLink(item.clientImagePath)}
            title={item.title}
            date={item.creationDate}
            text={item.subtitle}
            urlLink={`/noticia/${item.id}`}
            onClick={() => onClose()}
            mediaType={item.mediaType}
          />
        );
    }
  };

  render() {
    const {
      tabs,
      results,
      onClose,
      query,
      refs,
      enterSearch,
      searchByType,
      category,
      size,
      total,
      searchChangePage,
      page
    } = this.props;

    const { mount } = this.state;
    return (
      <StyledSearchModal mount={mount}>
        <MainSearch>
          <WrapperLogo>
            <Link onClick={this.handleClose} to="/">
              <IconLogo svg={Logo} size="xl" hover />
            </Link>
          </WrapperLogo>
          <IconClose
            svg={Close}
            color="dark"
            size="m"
            onClick={this.handleClose}
            hover
          />
          <FormSearch
            value={query}
            refs={refs}
            onChange={({ target }) => enterSearch(target.value)}
          />
          <TabsSearch>
            {tabs.map(item => (
              <TabHorizontal
                key={item.type}
                active={category === item.type}
                icon={item.icon}
                clicked={() => searchByType(item.type)}
                from="search"
              >
                {item.name} {`(${item.size})`}
              </TabHorizontal>
            ))}
          </TabsSearch>
          <div>
            {results.map(item => (
              <ItemResult key={uuid()}>
                {item.resultType === 'CONTENT' && this.getContent(item)}
                {item.resultType === 'DOCUMENT' && (
                  <DocumentItem
                    title={item.title}
                    date={item.creationDate}
                    urlLink="#"
                    onClick={e =>
                      this.getDocument(e, item.clientPath, item.resultType)
                    }
                    path={item.clientPath}
                  />
                )}
                {item.resultType === 'FOLDER' && (
                  <DocumentItem
                    title={item.title}
                    date={item.creationDate}
                    urlLink="#"
                    onClick={() => this.getFolder(item)}
                    path="/"
                  />
                )}
                {item.resultType === 'ASSOCIATION' && (
                  <GroupItem
                    title={item.name}
                    urlLink={`/departamento/${item.id}/informacion_general`}
                    onClick={onClose}
                  />
                )}
                {item.resultType === 'SECTION' && (
                  <SectionItem
                    title={item.name}
                    urlLink={this.getUrlFromSection(item.url)}
                    onClick={onClose}
                  />
                )}
                {item.resultType === 'USER' && (
                  <PersonItem
                    name={item.name}
                    lastname={item.lastname}
                    userId={item.userId}
                    subtitle={item.userProfile}
                    imgSrc={item.imgSrc}
                    avatar={item.avatar}
                    text={item.departmentName}
                    urlLink={`/perfil/${item.userId}/mi_perfil`}
                    onClick={onClose}
                    avatarPhoto={item.avatarPhoto}
                  />
                )}
              </ItemResult>
            ))}
            {!results.length && query.length >= 3 && (
              <ErrorPageSearch paragraphSearch={query} />
            )}
          </div>
          {results.length > 0 && (
            <SearchPaginator
              total={total}
              size={size}
              currentPage={page}
              onChangePage={searchChangePage}
            />
          )}
        </MainSearch>
      </StyledSearchModal>
    );
  }
}

SearchModal.propTypes = {
  query: PropTypes.string,
  onClose: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.id,
      active: PropTypes.bool,
      occurrences: PropTypes.number
    })
  ),
  results: PropTypes.arrayOf(SearchModel),
  searchByType: PropTypes.func,
  category: PropTypes.string,
  total: PropTypes.number,
  size: PropTypes.number,
  searchChangePage: PropTypes.func,
  page: PropTypes.number
};

SearchModal.defaultProps = {
  tabs: []
};

export default SearchModal;
